import React from "react";
import "./FormQuestion.scss";

export default function FormItem({ item }) {


      return (
        <div>
          {item?.form?.map(doc => {
            return(
              <div key={doc.question} className={ doc.answer || doc.subQuestion || (doc?.option_questions?.filter(answer => answer.selected === true)[0]?.option)  ? 'c-form-question-item' : 'c-form-question-item hidden' }>
                <h2 className="c-form-question">{doc.question}</h2>
                <p className="c-form-question-response">{doc.answer ? doc.answer : doc?.option_questions?.filter(answer => answer.selected === true)[0]?.option}</p>
                <div className={doc.subQuestion || doc?.option_questions?.filter(answer => answer.selected === true)[0]?.sub_question?.answer ? "c-form-subquestion" : "hidden"}>
                    <div className="c-form-subquestion-arrow"></div>
                    <p className="c-form-subquestion-response">{doc.subAnswer ? (doc.subAnswer) : doc?.option_questions?.filter(answer => answer.selected === true)[0]?.sub_question?.answer}</p>
                </div>
              </div>
            )
          })}
        </div>
      )


  }
// }
